const N0_AUTHORIZED = [401, 403];

/**
 * Retorna false si el error es 401 o 403. Para evitar que se muestre modales de error superpuesto con el modal de login o permission error.
 * @param {number} status
 * @returns {boolean}
 */
export const isServiceError = status => {
  return !N0_AUTHORIZED.includes(status);
};
